export const MAP_MODE = {
  ANALYZE: 'mode-analyze',
  FEATURES: 'mode-features',
  MOSAICS: 'mode-mosaics',
  SAVED_SEARCHES: 'mode-saved-searches',
  SEARCH: 'mode-search',
  SUBSCRIPTIONS: 'mode-subscriptions',
} as const;
